import { useState } from 'react'
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import Ionicons from '@expo/vector-icons/Ionicons'
import { useThemeColors } from '../../lib/useThemeColors'
import { fonts } from '../../lib/theme'

export default function AnnouncementBanner({ announcement }) {
  const tc = useThemeColors()
  const [dismissed, setDismissed] = useState(false)

  if (!announcement || dismissed) return null

  return (
    <View style={[styles.container, { backgroundColor: tc.bgCard, borderColor: tc.rosa }]}>
      <View style={styles.header}>
        <View style={styles.titleRow}>
          <Ionicons name="megaphone-outline" size={16} color={tc.rosaText} />
          <Text style={[styles.title, { color: tc.rosaText }]}>{announcement.title}</Text>
        </View>
        <TouchableOpacity onPress={() => setDismissed(true)} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
          <Ionicons name="close" size={18} color={tc.textMuted} />
        </TouchableOpacity>
      </View>
      <Text style={[styles.body, { color: tc.text }]}>{announcement.body}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    borderLeftWidth: 4,
    borderWidth: 1,
    padding: 14,
    marginBottom: 16,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
  },
  title: {
    fontFamily: fonts.condensedBold,
    fontSize: 14,
    letterSpacing: 0.3,
    flex: 1 },
  body: {
    fontSize: 13,
    lineHeight: 19,
  },
})